/* eslint-disable import/no-unresolved */
import React, { Fragment } from 'react';
import { FilterContainer } from '@components/noc-metric-panel';
import { useSelector } from 'react-redux';
import { nocModeSelector } from '@store/noc/base/selectors';
import { featureSelector } from '@store/common/selectors';
import featureNames from '@utils/featureToggle/constants';
import { NOC_MODE_TRENDS } from '@utils/constants';
import { filterSelector as filtersModeFilterSelector } from '@store/noc/filtersData/selectors';
import { filterSelector as trendsModeFilterSelector } from '@store/noc/trendsData/selectors';
import { NocWrapper, FilterWrapper, ModalMask } from '../styled';
import Content from './Content';
import TopPanel from './TopPanel';

const Wrapper = (props) => {
  const {
    filterContainer,
    changeFilterContainerVisibility,
    setView,
    currentShareId,
    pageType,
    isSharing,
    pageKeyForSaveService,
  } = props;

  const MAX_NOC_FILTERS = useSelector(featureSelector(featureNames.REALTIME_MAX_FILTERS));

  const mode = useSelector(nocModeSelector);
  let nocFilters: any[] = [];
  let maxSelectedFilters = MAX_NOC_FILTERS;
  const trendsModeFilter = useSelector(trendsModeFilterSelector);
  const filtersModeFilter = useSelector(filtersModeFilterSelector);

  if (mode === NOC_MODE_TRENDS) {
    nocFilters = [trendsModeFilter];
  } else {
    const allFilters = filtersModeFilter;
    nocFilters = allFilters.filter((filter) => filter.fid);
    maxSelectedFilters = MAX_NOC_FILTERS - (allFilters.length - nocFilters.length);
  }

  return (
    <NocWrapper>
      <TopPanel
        nocMode={mode}
        setView={setView}
        setShowFilterPanel={changeFilterContainerVisibility}
        currentShareId={currentShareId}
        pageType={pageType}
        isSharing={isSharing}
        pageKeyForSaveService={pageKeyForSaveService}
      />
      <Content />
      {filterContainer.visible ? (
        <Fragment>
          <ModalMask id="modal" />
          <FilterWrapper>
            <FilterContainer
              mode={mode}
              nocFilters={nocFilters}
              maxFilters={MAX_NOC_FILTERS}
              maxSelectedFilters={maxSelectedFilters}
            />
          </FilterWrapper>
        </Fragment>
      ) : null}
    </NocWrapper>
  );
};

export default Wrapper;
